import { IReport } from "../../interface/IReport"

const filterReportData = (data: IReport[] | undefined | null): IReport[] => {
    if (!data || !Array.isArray(data)) return []

    return data
        .map((report: IReport) => {
            const lines: any[] = Array.isArray(report.calendarLines) ? report.calendarLines : []
            const validLines = lines.filter((line: any) => {
                const oncallId = line?.mserp_oncalltimeandattendancejobid
                if (oncallId === null || oncallId === undefined) return false
                if (typeof oncallId === 'string' && oncallId.trim() === '') return false
                return true
            })
            return { ...report, calendarLines: validLines }
        })
        .filter((report: IReport) => Array.isArray(report.calendarLines) && report.calendarLines.length > 0)
}

export default filterReportData